import React from 'react';
import styled from 'styled-components';
import {
  Link,
} from "react-router-dom";

const CardTicketsWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`


  const Title = styled(Link)`
    outline: none;
    text-decoration: none;
    color: #373D3F;
    font-size: 1.2em;
    font-weight: 400; 
    line-height: 100%;
    letter-spacing: 0.05em;
    padding-top: 1.1rem;
    margin-bottom: 0.2rem;
    `

const SubTitle = styled.h4`
    color: #555F61;
    font-size: 1em;
    font-weight: 300; 
    line-height: 100%;
  `
const SvgContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`


export default function CardTickets (props) {

  return (
    <CardTicketsWrapper>
      <Title to={'/tickets'}>Requests</Title>
      <SubTitle>{props.tickets.length} {props.tickets.length === 1 ? 'request' : 'requests'} pending!</SubTitle>
      <SvgContainer><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 439.3 529.7" width="150" height="220" fill='#4285F4'><path d="M0 529.7l108.9-117.1h330.4V0H.7L0 529.7zM338.7 173c20.5 0 37.2 16.6 37.2 37.2 0 20.5-16.6 37.2-37.2 37.2s-37.2-16.6-37.2-37.2c.1-20.5 16.7-37.2 37.2-37.2zM220 173c20.5 0 37.2 16.6 37.2 37.2 0 20.5-16.6 37.2-37.2 37.2-20.5 0-37.2-16.6-37.2-37.2.1-20.5 16.7-37.2 37.2-37.2zm-118.7 0c20.5 0 37.2 16.6 37.2 37.2 0 20.5-16.6 37.2-37.2 37.2-20.5 0-37.2-16.6-37.2-37.2 0-20.5 16.7-37.2 37.2-37.2z"/></svg></SvgContainer>
    </CardTicketsWrapper>
  )
}